var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lookliveStyle"},[_c('top-component'),_vm._v(" "),_c('div',{staticClass:"contentStyle"},[_c('div',{staticClass:"contentStyleChild"},[_c('iframe',{attrs:{"id":"lookLive","allowfullscreen":"true","border":"0","src":_vm.src}})])]),_vm._v(" "),_c('bottom-component')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-500211f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Live-Platform/Look-Live.vue
// module id = null
// module chunks = 